<template>
  <div class="pois-container">
    <div v-if="positionenabled" class="pois-grid-container">
      <div class="pois_topside_container">
        <div class="pois-init-text-container">
          <div class="init-text--1" v-html="$t('init-pois-text-1')" />
          <div class="init-text--2" v-html="$t('init-pois-text-2')" />
        </div>

        <div class="pois--slider-container mb-3 mt-3">
          <div class="slider-container--title">
            {{ $t("valuationFilters.search-radius") }} <small>({{ slidervalue }} m)</small>
          </div>
          <div class="slider-container--slider mt-3">
            <div class="slider">
              <singleRangeSlider v-model="slidervalue" unit="m" :step="10" :min="0" :max="1000" />
            </div>
            <div class="slider--btn">
              <button class="brains-type2-btn" @click="querypois()">{{ $t("search-pois") }}</button>
            </div>
          </div>
        </div>
        <div class="pois-number-text mt-5">
          {{ $t("points-of-interest") }} <small>({{ TotalPois }})</small>
          <div class="poisfilter">
            <popoverBtn class="container-popover-save" :button="true" activator="click" :border="true">
              <template v-slot:popoverName>{{ $t('mappoisFilter') }}</template>
              <div class="filterpois">
                <div class="container-checks">
                  <el-checkbox-group v-model="CheckPois">
                    <div v-for="(poisOption, index) in PoisTipes" :key="index">
                      <el-checkbox :label="poisOption.name" class="row-check checkbox-reverse">{{
                        $t(poisOption.name)
                      }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <el-button class="brains-type2-btn" @click="showmappois()"> {{ $t('showinmap') }}</el-button>
              </div>
            </popoverBtn>
          </div>
        </div>
        <div class="pois-type-container mt-1">
          <scrollTabs :scroll-container="'pois-list-container'" class="brains-asset-data-right--tabs-2">
            <scrollTab v-for="tipes in Pois" :key="tipes.tipo" :name="tipes.tipo" :target-id="tipes.tipo.replaceAll(' ', '')" />
          </scrollTabs>
        </div>
      </div>
      <div id="pois-list-container" class="pois_botside_container">
        <dataList v-for="(tipes, index) in Pois" :id="tipes.tipo.replaceAll(' ', '')" :key="index" class="mb-2" :title="tipes.tipo">
          <dataRow v-for="(pois, index2) in tipes.pois" :key="pois.name + '-' + index + '-' + index2">
            <div slot="col-title">{{ pois.name }}</div>
            <div slot="col-value">{{ pois.distance }} m</div>
          </dataRow>
        </dataList>
      </div>
    </div>
    <div v-else class="position-not-selected">
      {{ $t('position-not-selected') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dataList from '@/components/designComponents/dataList'
import dataRow from '@/components/designComponents/dataRow'
import singleRangeSlider from '@/components/designComponents/singleRangeSlider'
import scrollTabs from '@/components/designComponents/scrollTabs'
import scrollTab from '@/components/designComponents/scrollTab'
import popoverBtn from '@/components/designComponents/popoverBtn'
export default {
  name: 'Pois',
  components: { dataList, dataRow, singleRangeSlider, scrollTabs, scrollTab, popoverBtn },
  data() {
    return {
      slidervalue: 300,
      loading: false,
      CheckPois: []
    }
  },
  computed: {
    ...mapState('location', {
      position: (state) => state.position
    }),
    ...mapState('pois', {
      Pois: (state) => state.Pois
    }),
    positionenabled: function() {
      return this.position.latitude !== null && this.position.longitude !== null
    },
    TotalPois: {
      get() {
        return this.Pois.reduce((acc, item) => acc + item.pois.length, 0)
      }
    },
    PoisTipes: {
      get() {
        return [...new Set(this.Pois.map(it => { return it.tipo }))].map(it => {
          return {
            name: it,
            checked: false
          }
        })
      }
    }
  },
  watch: {
    position: function() {
      if (this.positionenabled) {
        this.querypois()
      }
    }
  },
  mounted() {
    if (this.positionenabled) {
      this.querypois()
    }
  },
  methods: {
    scrolltoitem(item) {
      document.getElementById(item).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    },
    querypois() {
      this.querypoisbd()
    },
    querypoisbd() {
      const vm = this
      vm.loading = true
      this.$store
        .dispatch('pois/GetPois', {
          latitude: vm.position.latitude,
          longitude: vm.position.longitude,
          radius: vm.slidervalue
        })
        .then(() => {
          vm.loading = false
          vm.formatLiteralsPois()
          vm.showmappois()
        }).catch(() => {
          vm.$message({
            showClose: true,
            message: vm.$t('error-getting-pois'),
            type: 'warning'
          })
        })
    },
    showmappois() {
      const vm = this
      vm.loading = true
      const pois = vm.Pois.filter(it => { return vm.CheckPois.includes(it.tipo) }).map(it => { return it.pois }).flat()
      this.$store
        .dispatch('pois/SetMapPois', pois)
        .then(() => {
          vm.loading = false
        }).catch(() => {
          vm.$message({
            showClose: true,
            message: vm.$t('error-getting-pois'),
            type: 'warning'
          })
        })
    },
    formatLiteralsPois() {
      this.Pois.forEach(poi => {
        poi.tipo_literal = 'poi-' + poi.tipo.replace(/[^A-Z0-9]+/ig, '-').toLowerCase()

        poi.pois.forEach(poi2 => {
          poi2.tipo_literal = 'poi-' + poi2.tipo.replace(/[^A-Z0-9]+/ig, '-').toLowerCase()
        })
      })
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.poisfilter {
  display: inline;
  margin-left: 10px;
}
.filterpois {
  width: 300px;
  padding: 5px;
}
.pois-container {
  width: 100%;
  height: 100%;

  .pois-grid-container {
    height: 100%;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;

    .pois_botside_container {
      overflow: scroll;
      margin-top: 10px;
    }
  }

  .pois-init-text-container {
    padding: 10px 15px 5px 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: justify;
    line-height: 20px;
  }

  .pois--slider-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-left: 25px;

    .slider-container--title {
      font-size: 18px;
      small {
        font-size: 12px;
        color: rgb(194, 194, 194);
      }
    }

    .slider-container--slider {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 15px;

      .slider {
        width: 85%;
        margin-right: 15px;

        &--btn {
          width: 13%;
        }
      }
    }
  }

  .pois-number-text {
    font-size: 18px;
    padding-left: 25px;
    small {
      font-size: 12px;
      color: rgb(194, 194, 194);
    }
  }

  .pois-type-container {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: wrap;

    .pois-type--btn {
      display: inline-block;
    }
  }

  .pois-list-container {
    //overflow: scroll;
  }
}

.hr-style {
  border-color: rgb(194, 194, 194);
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
